// extracted by mini-css-extract-plugin
module.exports = {"FeaturesBlock":"styles-module--FeaturesBlock--33T-b","Feature":"styles-module--Feature--1lf7Y"};